import { render, staticRenderFns } from "./MhImage.vue?vue&type=template&id=ca4863fc&"
import script from "./MhImage.vue?vue&type=script&lang=js&"
export * from "./MhImage.vue?vue&type=script&lang=js&"
import style0 from "./MhImage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../GbR/10__Projekte/2020-05-28__ROTORBOOKS/03  Website/wordpress/wp-content/themes/wp-kickstart-v3-theme/vue-cli-dev/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports